import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import Modal from '@components/common/Modal';
import { TouchableButton } from '@components/common/Touchable';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import styles from './CartActionPopUpV2.module.scss';
import { styleGenerator } from './CartActionPopUpHelper';
const CartActionPopUpV2 = ({
  actionType,
  isOpen,
  serverAppTheme,
  setIsOpen,
  actionFn,
}) => {
  const actionText = useMemo(() => {
    const actionMessageList = {
      sendAll: CUSTOM_MESSAGES().SEND_MULTIPLE_MSG,
      sendSingle: CUSTOM_MESSAGES().SINGLE_SEND_MSG,
      deleteAll: CUSTOM_MESSAGES().DELETE_MULTIPLE_MSG,
      sendSelected: CUSTOM_MESSAGES().SINGLE_SELECTED_SEND_MSG,
      delete_one: CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION,
      delete_many: CUSTOM_MESSAGES().MULTIPLE_DELETE_MSG,
      unsentRepeat_one: CUSTOM_MESSAGES().REPEAT_ITEM,
    };

    let currentMessage = actionMessageList[actionType.type];
    if (!currentMessage) {
      switch (true) {
        case actionType.type === 'delete' && actionType.data.length === 1:
          currentMessage = actionMessageList[`${actionType.type}_one`];
          break;
        case actionType.type === 'delete' && actionType.data.length > 1:
          currentMessage = actionMessageList[`${actionType.type}_many`];
          break;
        case actionType.type === 'unsentRepeat' && actionType.data.length === 1:
          currentMessage = actionMessageList[`${actionMessageList}_one`];
          break;
        default:
          currentMessage = '';
      }
    }
    return currentMessage;
  }, []);

  const actionModal = useMemo(() => {
    return styleGenerator({ actionType, serverAppTheme });
  }, [actionType.type, serverAppTheme]);

  return (
    <Modal
      isOpen={isOpen}
      isModalCenter
      style={actionModal.modal}
      customClass="h-100 w-100"
      customClass2="h-100 w-100"
      noBackground
    >
      <div
        className="justify-content-center align-items-center text-center h-100"
        style={actionModal.parentContainer}
      >
        <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
          <div className="col-12 fs_18 fw-700 text-center h-auto">
            Are You Sure ?
          </div>
          <br />
          <div
            className={cn(
              'col-12 px-0 fs_15 fw-400 text-center h-auto',
              actionType?.type === 'delete' &&
                actionType?.data?.length === 1 &&
                'pt-3'
            )}
          >
            {actionText}
          </div>
        </div>
        <div
          className={cn(
            'col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute',
            styles.actionPopUpButtons
          )}
        >
          <div className="col-6 pl-0 pr-1">
            <TouchableButton
              type="submit"
              className={cn(styles.btnSecondary, 'col-12 fs_24 fw-600 btn-44')}
              onClick={event => {
                event.preventDefault();
                setIsOpen(false);
                // onClose('no');
              }}
              style={actionModal.noButton}
              rippleEffect={true}
            >
              {LABEL().NO}
            </TouchableButton>
          </div>
          <div className="col-6 pl-1 pr-0">
            <TouchableButton
              type="submit"
              className={cn(
                styles.btnPrimary,
                'col-12 btn-ripple fs_24 fw-600'
              )}
              onClick={event => {
                event.preventDefault();
                setIsOpen(false);
                actionFn?.();
              }}
              style={actionModal.yesButton}
              rippleEffect={true}
            >
              {LABEL().YES}
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const mapStateToProps = ({ theme }) => ({
  serverAppTheme: theme.serverAppTheme,
});
export default connect(mapStateToProps, mapDispatchToProps)(CartActionPopUpV2);
